import useClassNames from '@medflex/hooks/useClassNames';
import format from 'date-fns/format';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from './Avatar';

const ChatMessageHeader = ({
  avatar,
  initials,
  name,
  time,
  info,
  isSender,
  isInSenderPractice,
  className,
  ...props
}) => {
  const { t } = useTranslation('components');
  const cn = useClassNames(
    () => [
      'flex',
      'items-center',
      'mt-3',
      'min-w-0',
      'gap-2',
      (isSender || isInSenderPractice) && 'flex-row-reverse',
      className,
    ],
    [className],
  );
  return (
    <div
      data-component="ChatMessageHeader"
      className={cn}
      {...props}
      title={`${name}${info ? ` (${info})` : ''}`}
    >
      <Avatar src={avatar} initials={initials} alt={name} size="6" />
      <div className="flex max-w-full overflow-hidden">
        <span
          className={`text-xs font-semibold max-w-full inline-block truncate ${
            isSender ? 'text-blue-500' : 'text-slate-600'
          }`}
        >
          {name}
          {/* </span> */}
          {info && <span className="text-xs text-slate-500">&nbsp; ({info})</span>}
        </span>
        <span className="text-xs text-slate-500 flex-shrink-0 whitespace-no-wrap">
          &nbsp;
          {t('ChatMessageHeader.time', { time: format(time, 'HH:mm') })}
        </span>
      </div>
    </div>
  );
};

ChatMessageHeader.propTypes = {
  avatar: PropTypes.string,
  initials: PropTypes.string,
  name: PropTypes.string.isRequired,
  info: PropTypes.string,
  isSender: PropTypes.bool,
  isInSenderPractice: PropTypes.bool,
  time: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

ChatMessageHeader.defaultProps = {
  isSender: false,
  isInSenderPractice: false,
};

export default ChatMessageHeader;
